import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const cashierRouter = {
  path: '/cashier',
  component: Layout,
  name: 'cashier',
  redirect: 'cashier',
  children: [
    {
      path: 'cashier',
      component: () => import('@/views/cashier/index'),
      name: 'cashier.index',
      meta: { title: i18n.t('message.cashier')}
    },
    {
      path: 'cashier/history',
      component: () => import('@/views/cashier/history'),
      name: 'history',
      meta: { title: i18n.t('message.history')}
    },
  ]
}

export default cashierRouter